'use client';

import React, {
  type Dispatch,
  type SetStateAction,
  type ReactNode,
  createContext,
  useContext,
  useMemo,
  useState,
} from 'react';

type CurrentFilterStatusProps = {
  children: ReactNode;
};

type CurrentFilterStatusContextType = {
  currentFiltersStatus?: TransportFiltersResponse;
  setCurrentFiltersStatus: Dispatch<SetStateAction<TransportFiltersResponse>>;
};

const CurrentFilterStatusContext = createContext<CurrentFilterStatusContextType>({
  setCurrentFiltersStatus: () => null,
});

export function CurrentFilterStatusProvider(props: CurrentFilterStatusProps) {
  const { children } = props;
  const [currentFiltersStatus, setCurrentFiltersStatus] = useState<TransportFiltersResponse>({});

  const memoizedValue = useMemo(
    () => ({
      currentFiltersStatus,
      setCurrentFiltersStatus,
    }),
    [currentFiltersStatus, setCurrentFiltersStatus]
  );

  return <CurrentFilterStatusContext.Provider value={memoizedValue}>{children}</CurrentFilterStatusContext.Provider>;
}

export function useCurrentFilterStatus() {
  const context = useContext(CurrentFilterStatusContext);

  if (context === undefined) {
    throw new Error('useCurrentFilterStatus must be within a CurrentFilterStatusProvider');
  }
  return context;
}
